<template>
  <v-chip-group column>
    <v-chip
      v-for="chip in chips"
      @click="handleClickFilter"
      :key="chip.id"
      outlined
      close
      color="secondary"
      @click:close="removeFilter(chip)"
      small
    >
      {{ chip.label }}: {{ chip.value }}
    </v-chip>
    <template v-if="chips.length">
      <v-chip @click="clear()" small color="red" outlined>
        Limpar <v-icon small right>mdi-close-circle</v-icon>
      </v-chip>
      <v-chip @click="handleClickFilter" color="primary" outlined small>
        Filtrar
        <v-icon small right> mdi-filter-menu </v-icon>
      </v-chip>
    </template>
    <template v-else>
      <v-chip
        v-for="chip in defaults"
        @click="aplyDefault(chip)"
        :key="chip.label"
        color="secondary"
        outlined
        small
      >
        {{ chip.label }}
        <v-icon small right>mdi-filter</v-icon>
      </v-chip>
      <v-chip @click="handleClickFilter" color="primary" outlined small>
        Filtrar
        <v-icon small right> mdi-filter-menu </v-icon>
      </v-chip>
    </template>
  </v-chip-group>
</template>

<script>
export default {
  props: {
    headers: Array,
    filters: Object,
    defaults: Array
  },

  methods: {
    clear() {
      this.$emit("clear");
    },

    removeFilter(chip) {
      this.$emit("filter", {
        ...this.filters,
        [chip.id]: undefined
      });
    },

    aplyDefault(chip) {
      this.$emit("filter", chip.filters);
    },

    handleClickFilter() {
      this.$emit("click:filter");
    }
  },

  computed: {
    chips() {
      const value = [];

      for (const property in this.filters) {
        const header = this.headers.find(header => header.id === property);
        if (!header) {
          continue;
        }

        if (!this.filters[property]) {
          continue;
        }

        value.push({
          id: header.id,
          label: header.label,
          value: this.filters[property]
        });
      }

      return value;
    }
  }
};
</script>
